<template>
    <div>
        <div class="d-flex">
            <div class="flex-1-0">
                <h1><v-icon :icon="entity.ICON"></v-icon> {{ entity.PLURAL }}</h1>
            </div>
            <div class="d-flex">
                <stocktake-loader></stocktake-loader>
                <v-btn color="primary"
                       v-if="entity.FORM != null"
                       @click="addEntity"
                       prepend-icon="mdi-plus">
                    ADD ADJUSTMENT
                </v-btn>
            </div>
        </div>
        <v-skeleton-loader class="mx-auto border"
                           :loading="stockLoading"
                           type="table">
            <v-table class="w-100">
                <thead>
                    <tr>
                        <td colspan="2">
                            <div>
                                <v-text-field label="Search..."
                                              prepend-icon="mdi-magnify"
                                              v-model="searchTerm"
                                              density="compact"
                                              hide-details="true"
                                              clearable></v-text-field>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="w-80">Colour</th>
                        <th class="w-20">
                            <v-table class="w-100" density="compact">
                                <tr>
                                    <th class="w-50 text-right">Quantity</th>
                                </tr>
                            </v-table>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in paginatedStock" :key="row.id">
                        <td><router-link :to="$constants.entities.Colour.ROUTE+row.id"><span v-html="formatSearchName(row.colourName, searchTerm)"></span></router-link></td>
                        <td>
                            <v-table class="w-100" density="compact">
                                <tr v-for="rack in row.rackLevel" :key="rack.rack">
                                    <td class="text-right">{{ rack.quantity }}</td>
                                </tr>
                            </v-table>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="stock && stock.length > 0 && (!searchTerm || searchTerm.length == 0)">
                    <tr>
                        <td colspan="2">
                            <div class="v-data-table-footer">
                                <div class="v-data-table-footer__items-per-page">
                                    <span class="text-caption mr-2">Items per page:</span>
                                    <v-select v-model="itemsPerPage"
                                              :items="itemsPerPageOptions"
                                              variant="outlined"
                                              density="compact"
                                              hide-details
                                              style="width: 80px;"></v-select>
                                </div>

                                <div class="v-data-table-footer__info">
                                    {{ paginationText }}
                                </div>

                                <div class="v-data-table-footer__pagination">
                                    <v-btn icon
                                           variant="text"
                                           :disabled="currentPage === 1"
                                           @click="currentPage = 1">
                                        <v-icon>mdi-page-first</v-icon>
                                    </v-btn>
                                    <v-btn icon
                                           variant="text"
                                           :disabled="currentPage === 1"
                                           @click="currentPage--">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>

                                    <span class="mx-2">{{ currentPage }} of {{ totalPages }}</span>

                                    <v-btn icon
                                           variant="text"
                                           :disabled="currentPage === totalPages"
                                           @click="currentPage++">
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-btn>
                                    <v-btn icon
                                           variant="text"
                                           :disabled="currentPage === totalPages"
                                           @click="currentPage = totalPages">
                                        <v-icon>mdi-page-last</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </v-table>
        </v-skeleton-loader>

        <edit-entity-dialog></edit-entity-dialog>
    </div>
</template>
<style scoped>
</style>
<script>
    import { mapActions, mapState } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { formatSearchName } from "../../mixins/searchMixins";
    function initialState() {
        return {
            saving: false,
            loading: false,
            data: [],
            currentPage: 1,
            itemsPerPage: 10,
            itemsPerPageOptions: [5, 10, 25, 50, 100],
            searchTerm : ''
        };
    }
    export default {
        name: "StockPanel",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadStock();
        },
        components: {
        },
        props: {
        },
        methods: {
            ...mapActions([
                "loadStock",
                'addEntity',
                "showErrorSnack",
                "showSuccessSnack",
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            numberWithCommas,
            formatSearchName
        },
        computed: {
            ...mapState({
                entity: (state) => state.entities.entity,
                stock: (state) => state.stock.stock,
                stockLoading: (state) => state.stock.stockLoading,
            }),

            totalPages() {
                if (!this.stock || this.stock.length === 0) return 1;
                return Math.ceil(this.stock.length / this.itemsPerPage);
            },

            paginatedStock() {
                if (this.searchTerm && this.searchTerm.length > 0) {
                    let upperSearch = this.searchTerm.toUpperCase();
                    return this.stock.filter(item => {
                        return item.colourName.toUpperCase().includes(upperSearch);
                    });
                } else {
                    if (!this.stock || this.stock.length === 0) return [];

                    const start = (this.currentPage - 1) * this.itemsPerPage;
                    const end = start + this.itemsPerPage;
                    return this.stock.slice(start, end);
                }
            },

            paginationText() {
                if (!this.stock || this.stock.length === 0) return 'No items';

                const start = (this.currentPage - 1) * this.itemsPerPage + 1;
                const end = Math.min(this.currentPage * this.itemsPerPage, this.stock.length);
                return `${start}-${end} of ${this.stock.length}`;
            }
        },

        watch: {
            // Reset to first page when items per page changes
            itemsPerPage() {
                this.currentPage = 1;
            },

            // Reset to first page when stock data changes
            stock() {
                this.currentPage = 1;
            },

            // Ensure current page doesn't exceed total pages
            totalPages(newVal) {
                if (this.currentPage > newVal) {
                    this.currentPage = Math.max(1, newVal);
                }
            }
        }
    };
</script>